import { Typography } from '@mui/material';
import { useAppSelector } from 'api';
import { PageContainer } from 'app';
import { UserMaintenanceTabContainer } from './tabs/UserMaintenanceTabContainer';
import { UserMaintenanceAutoComplete } from './UserMaintenanceAutoComplete';

export const UserMaintenancePage: React.FC = () => {
  const { selectedUser } = useAppSelector(state => state.userMaintenance);

  return (
    <PageContainer>
      <Typography variant="subtitle1" p={1}>
        User Maintenance
      </Typography>
      <UserMaintenanceAutoComplete />

      {selectedUser && <UserMaintenanceTabContainer />}
    </PageContainer>
  );
};
